<template>
   <el-dialog title="选择邮箱" 
      :visible.sync="emailChooseDialog" 
      :close-on-click-modal="false" 
      @close="cancleDialog"
      width="560px" >
      <el-table ref="singleTable" :data="tableData" highlight-current-row @current-change="handleCurrentChange" style="width: 100%">
        <el-table-column type="index" width="50">
        </el-table-column>
        <el-table-column property="email" label="邮箱"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancleDialog" size="small">取 消</el-button>
        <el-button type="primary" @click="submit" size="small">保 存</el-button>
      </span>
   </el-dialog>
</template>
<script>
export default {
  props: ['emailChooseDialog','emailData'],
  data() {
    return {
      tableData: [],
      chooseEmailRow: null
    }
  },
  watch: {
    'emailData': {
      handler(newVal) {
        this.tableData = newVal;
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.chooseEmailRow = val;
    },
    cancleDialog() {
      this.$emit('emailChoseClose')
    },
    submit() {
      this.$emit('emailChooseSend', this.chooseEmailRow)
    }
  }
}
</script>
<style lang='less' scoped>
 
 </style>